import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/NavBar";
import { useAppDispatch, useAppSelector } from "../store/store";
import PostAction from "../store/post/action";
import LoadingView from "../components/LoadingView";
import Clothes from "../models/clothes/clothes.model";

const MyPostsPage = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { user } = useAppSelector((s) => s.auth);
    const appData = useAppSelector((s) => s.app?.data);
    const { isLoading, myPostsData, error } = useAppSelector((s) => s.post);
    const [showPostsLimitModal, setShowPostsLimitModal] = useState(false);

    useEffect(() => {
        if (user?.id) PostAction.getMyPosts(user.id, dispatch);
    }, [user?.id, dispatch]);

    const getPostsLimit = () => {
        if (user?.subscription?.status === "active" && user.subscription.posts_limit != null)
            return user.subscription.posts_limit;
        if (appData?.user_posts_limit != null) return appData.user_posts_limit;
        return 5;
    };

    const onItemClick = (item: Clothes) => {
        navigate("/item", { state: { item } });
    };

    const onEdit = (e: React.MouseEvent, item: Clothes) => {
        e.stopPropagation();
        navigate("/my-posts/edit", { state: { item } });
    };

    const onAdd = () => {
        const limit = getPostsLimit();
        const currentCount = myPostsData?.length ?? 0;
        if (user && currentCount < 100) {
            navigate("/my-posts/add");
        } else {
            setShowPostsLimitModal(true);
        }
    };

    const isApproved = user?.status === "approved";

    return (
        <div className="min-h-screen bg-[#f8f2ed] font-manrope">
            <Navbar />
            <div className="max-w-6xl mx-auto px-4 py-6">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-semibold text-[#704e37]">Shpalljet e mia</h1>
                    {isApproved && (
                        <button
                            onClick={onAdd}
                            className="px-4 py-2 rounded-lg bg-[#704e37] text-white font-medium hover:opacity-90"
                        >
                            Shto shpallje
                        </button>
                    )}
                </div>
                {user?.status === "pending" && (
                    <p className="text-amber-700 bg-amber-50 p-3 rounded-lg mb-4">
                        Llogaria juaj është në pritje të aprovimit. Pas aprovimit do të mund të shtoni shpallje.
                    </p>
                )}
                {isLoading && <LoadingView size={50} />}
                {error && <p className="text-red-500">{error}</p>}
                {!isLoading && !error && myPostsData && myPostsData.length > 0 && (
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                        {myPostsData.map((item) => (
                            <div
                                key={`${item.seller_id}_${item.id}`}
                                className="bg-white rounded-lg shadow overflow-hidden group relative"
                            >
                                <button
                                    onClick={() => onItemClick(item)}
                                    className="text-left w-full"
                                >
                                    <div className="aspect-[3/4] bg-gray-100">
                                        {item.images?.[0] ? (
                                            <img
                                                src={item.images[0]}
                                                alt={item.name}
                                                className="w-full h-full object-cover"
                                            />
                                        ) : (
                                            <div className="w-full h-full flex items-center justify-center text-gray-400">No image</div>
                                        )}
                                    </div>
                                    <div className="p-2">
                                        <p className="font-medium text-gray-800 truncate">{item.name}</p>
                                        <p className="text-sm text-[#704e37]">
                                            {item.prices?.isFree ? "Falas" : `${item.prices?.sellPrice ?? 0} €`}
                                        </p>
                                    </div>
                                </button>
                                {isApproved && (
                                    <button
                                        onClick={(e) => onEdit(e, item)}
                                        className="absolute top-2 right-2 px-2 py-1 bg-white/90 rounded text-sm text-[#704e37] hover:bg-[#704e37] hover:text-white"
                                    >
                                        Ndrysho
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                )}
                {!isLoading && !error && (!myPostsData || myPostsData.length === 0) && (
                    <p className="text-gray-500">Nuk keni shpallje.</p>
                )}
            </div>

            {showPostsLimitModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" onClick={() => setShowPostsLimitModal(false)}>
                    <div className="bg-white rounded-xl shadow-lg max-w-sm w-full p-6 text-center" onClick={(e) => e.stopPropagation()}>
                        <p className="text-gray-800 font-medium mb-2">Kufiri i shpalljeve</p>
                        <p className="text-gray-600 text-sm mb-4">
                            Keni arritur kufirin e shpalljeve ({getPostsLimit()}). Për të shtuar më shumë shpallje, kontaktoni ose aktivizoni abonimin.
                        </p>
                        <button
                            onClick={() => setShowPostsLimitModal(false)}
                            className="w-full py-2.5 rounded-lg bg-[#704e37] text-white font-medium hover:opacity-90"
                        >
                            Mbyll
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MyPostsPage;
